import { bonusType } from "redux/ducks/bonus/bonusTypes";
import { bonusBuyNumbers } from "redux/ducks/purchase/purchaseTypes";
import { genderType } from "redux/commonTypes";

/**
 * Local UI preview of fill-profile gift (server no longer returns feature list).
 * Female: boost 1 + pin 1d + invisible 1d (no plan).
 * Male/NB: Basic 30d if no active plan; always boost 1 + pin 1d + invisible 30d.
 */
export function fillGiftPreview(
  gender: genderType | string | undefined,
  hasActivePlan = false,
): Array<bonusType> {
  if (gender === "Female") {
    return [
      { id: 1, type: bonusBuyNumbers.BoostRating, count: 1 },
      { id: 2, type: bonusBuyNumbers.PinnedProfile, duration: 1 },
      { id: 3, type: bonusBuyNumbers.Invisible, duration: 1 },
    ];
  }

  const perks: Array<bonusType> = [
    { id: 1, type: bonusBuyNumbers.BoostRating, count: 1 },
    { id: 2, type: bonusBuyNumbers.PinnedProfile, duration: 1 },
    { id: 3, type: bonusBuyNumbers.Invisible, duration: 30 },
  ];

  if (hasActivePlan) {
    return perks;
  }

  return [{ id: 0, type: bonusBuyNumbers.Premium, duration: 30 }, ...perks];
}
